<template>
  <div class="vch-my-information-form">
    <div class="vch-grid mb-xl">
      <h2 class="vch-col-12 vch-col-md-6 vch-col-xl-4 heading-xl uppercase">
        {{ infoTitle }}
      </h2>
    </div>
    <template v-if="!formSuccess">
      <div class="vch-grid">
        <div
          class="
            vch-col-12
            vch-col-md-10
            vch-col-offset-md-1
            vch-col-lg-8
            vch-col-offset-lg-2
            vch-col-xl-6
            vch-col-offset-xl-3
          "
        >
          <p class="vch-contact-form__instructions">
            {{ formMandatoryInstruction }}
          </p>
          <slot name="form">Form Here</slot>
        </div>
      </div>
    </template>
    <template v-else>
      <h2 class="heading-lg uppercase mb-xxs">
        <span class="heading-lg-em">{{ completeTitlePrimary }}</span
        ><br />{{ completeTitleSecondary }}
      </h2>
      <!-- <p class="heading-md mb-xl" v-html="completeMessage"></p> -->
      <a
        href="/"
        class="button -primary --fit-content"
        @click="pushReturnTag"
        >{{ confirmButtonText }}</a
      >
    </template>
  </div>
</template>
<script>
import { parseSitecoreForm, bindFormField } from 'Utils/form';
import { mixinFormRecaptcha } from 'Mixins/formRecaptcha/formRecaptcha';
import { pushEvent } from 'Utils/datalayer';
export default {
  name: 'vch-my-information-form',
  mixins: [mixinFormRecaptcha],
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    formMandatoryInstruction: {
      type: String,
    },
    defaultErrorMessage: {
      type: String,
      required: false,
      default: 'An error occured while processing your request.',
    },
    testHost: {
      type: String,
      required: false,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    confirmTitlePrimary: {
      type: String,
      required: true,
    },
    confirmTitleSecondary: {
      type: String,
      required: true,
    },
    titleSubheading: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      infoTitle: this.formTitle,
      titleSecondary: this.titleSubheading,
      formSuccess: false,
      useEmailFlow: false,
      fields: [],
      formProperties: null,
      parser: new DOMParser(),
      errorWrapperNode: null,
    };
  },
  computed: {
    completeTitleSecondary() {
      return this.titleSecondary;
    },
    completeTitlePrimary() {
      return this.useEmailFlow
        ? this.confirmTitleNewsletterPrimary
        : this.confirmTitlePrimary;
    },
    formActionUrl() {
      return process.env.NODE_ENV === 'production'
        ? this.formProperties.formAction
        : `${this.testHost}${this.formProperties.formAction}`;
    },
  },
  mounted() {
    const formNode = this.$slots.form[0].children[0].children[0];
    if (!formNode?.elm) {
      return;
    }

    this.formProperties = parseSitecoreForm(formNode?.elm);
    formNode.elm.addEventListener('submit', this.onSubmit);

    this.errorWrapperNode = document.createElement('div');
    this.errorWrapperNode.setAttribute('role', 'status');
    this.errorWrapperNode.classList.add('vch-contact-form__errorSummary');
    const submitButton = formNode?.elm.querySelector('input[type="submit"]');
    submitButton.parentNode.insertBefore(this.errorWrapperNode, submitButton);

    formNode.children
      .filter((node) => node.tag === 'div' || node.tag === 'input')
      .forEach((node) => {
        const foundFieldInfo = bindFormField(node);
        if (foundFieldInfo.nestedFieldInfo.length) {
          this.fields.push(...foundFieldInfo.nestedFieldInfo);
        }
        this.fields.push(foundFieldInfo);
      });
  },

  methods: {
    setErrorMessage(errorMessage) {
      this.errorWrapperNode.innerText = errorMessage;
    },

    validateCheckbox(fieldInfo) {
      if (!fieldInfo.inputElement.checked) {
        const validationError = fieldInfo.inputElement.getAttribute(
          SITECORE_ISCHECKED_ATTRIBUTE
        );
        applyValidationError(
          fieldInfo.inputElement,
          fieldInfo.validationMsgTarget,
          validationError
        );
        return validationError;
      } else {
        clearValidationError(
          fieldInfo.inputElement,
          fieldInfo.validationMsgTarget
        );
      }
      return null;
    },
    async onSubmit(e) {
      e.preventDefault();
      if (!this.validateFields()) {
        return; // Validation failed, so prevent form submission
      }
      let submitButton = document.querySelector('.vch-form-submit');
      // Recaptcha Flow via Mixin
      this.peformRecaptcha()
        .then(async (canSubmit) => {
          if (canSubmit) {
            if (submitButton) {
              submitButton.setAttribute('disabled', 'disabled');
            }
            await fetch(this.formActionUrl, {
              method: 'POST',
              mode: process.env.NODE_ENV === 'production' ? 'cors' : 'no-cors',
              body: this.assembleFormData(),
            })
              .then((response) => {
                if (response.status >= 400 && response.status < 600) {
                  throw new Error(this.defaultErrorMessage);
                }
                return response.text();
              })
              .then((response) => {
                const htmlResponse = this.parser.parseFromString(
                  response,
                  'text/xml'
                );
                const errorWrapper = htmlResponse.querySelector(
                  '.validation-summary-errors'
                );
                if (errorWrapper) {
                  const serverErrorMsgs = errorWrapper.querySelectorAll('li');
                  const summaryErrors = Array.from(serverErrorMsgs).map(
                    (msg) => msg.textContent
                  );
                  this.setErrorMessage(summaryErrors[0]);
                  if (submitButton) {
                    submitButton.removeAttribute('disabled');
                  }
                } else {
                  this.formSuccess = true;
                  //this.pushSubmitTags();
                  setTimeout(() => {
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }, 100);
                }
              })
              .catch((error) => {
                this.setErrorMessage(error.message);
                if (submitButton) {
                  submitButton.removeAttribute('disabled');
                }
              });
          }
        })
        .catch(() => {
          this.setErrorMessage(this.defaultErrorMessage);
          if (submitButton) {
            submitButton.setAttribute('disabled', 'disabled');
          }
        });
    },
    validateFields() {
      const validationErrors = [];
      this.fields.forEach((field) => {
        const fieldErrors = field.validate();
        validationErrors.push(...fieldErrors);
      });

      if (validationErrors.length > 0) {
        // this.setErrorMessage(this.errorMessageFormIncomplete);
        return false;
      }
      return true;
    },
    assembleFormData() {
      const formData = new FormData();
      this.fields.forEach((field) => {
        if (field.inputElement) {
          formData.append(field.inputElement.name, field.inputElement.value);
        }
        field.hiddenFields.forEach((hiddenField) => {
          if (hiddenField.name) {
            formData.append(hiddenField.name, hiddenField.value);
          }
        });
      });
      return formData;
    },
    pushReturnTag() {
      pushEvent({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'appendix',
        eventAction: 'select::my-information-form',
        eventLabel: `${this.confirmButtonText.toLowerCase()}::${
          window.location.origin
        }`,
        event_name: 'body_button_click',
        cta_name: `${this.confirmButtonText.toLowerCase()}`,
        link_url: `${window.location.origin}`,
        module_name: 'my-information-form',
      });
    },
  },
};
</script>
<style lang="scss" src="./my-information-form.scss" scoped></style>
